'use strict';
module.exports = [
  // type
  require('./Chain'),

  // construction function
  require('./function/chain')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/chain/index.js
// module id = 1339
// module chunks = 0